import config from "../../assets/js/conf/config";
import request from "../../assets/js/utils/request";

// 任务大厅 - 获取任务分组和任务列表
export function getTaskHall(data){
	return request.get(config.baseApi+"/merchant/task/hall",data)
}

// 任务详情
export function getTaskDetail(data){
	return request.get(config.baseApi+"/merchant/task/detail",data)
}

// 我的任务列表
export function getMyTasks(data){
	return request.get(config.baseApi+"/merchant/task/my-tasks",data)
}

// 完成任务
export function completeTask(data){
	return request.post(config.baseApi+"/merchant/task/complete",data)
}

// 任务统计
export function getTaskStats(data){
	return request.get(config.baseApi+"/merchant/task/stats",data)
}

// 完成记录
export function getCompletionLogs(data){
	return request.get(config.baseApi+"/merchant/task/completion-logs",data)
}
